import React from "react";
import {
  FaComments,
  FaThumbtack,
  FaLightbulb,
} from "react-icons/fa";

export default function Sidebar({
  posts = [],
}) {
  const pinned = posts.filter((p) => p.pinned).length;

  return (
    <aside className="space-y-6">

      {/* FORUM */}
      <div className="rounded-2xl border border-neutral-200 bg-white p-5">
        <div className="flex items-center gap-3">
          <div className="rounded-xl bg-[#E8F7F5] p-3 text-[#3BAFA3]">
            <FaComments />
          </div>

          <div>
            <h2 className="font-semibold text-neutral-900">
              Dialogforum
            </h2>

            <p className="text-sm text-neutral-500">
              Intern kommunikation
            </p>
          </div>
        </div>
      </div>

      {/* ÖVERSIKT */}
      <div className="rounded-2xl border border-neutral-200 bg-white p-5">
        <h3 className="mb-4 font-semibold text-neutral-900">
          Översikt
        </h3>

        <StatRow
          icon={<FaComments />}
          label="Inlägg"
          value={posts.length}
        />

        <StatRow
          icon={<FaThumbtack />}
          label="Fästa"
          value={pinned}
        />
      </div>

      {/* TIPS */}
      <div className="rounded-2xl border border-[#3BAFA3]/20 bg-[#E8F7F5] p-5">
        <div className="mb-3 flex items-center gap-2 text-[#3BAFA3]">
          <FaLightbulb />
          <h3 className="font-semibold">
            Dagens tips
          </h3>
        </div>

        <p className="text-sm leading-relaxed text-neutral-700">
          Använd fästa inlägg för viktig information och håll
          rubrikerna korta så blir forumet lättare att överblicka.
        </p>
      </div>
    </aside>
  );
}

function StatRow({
  icon,
  label,
  value,
}) {
  return (
    <div className="mb-3 flex items-center justify-between last:mb-0">
      <div className="flex items-center gap-2 text-neutral-600">
        {icon}
        <span className="text-sm">{label}</span>
      </div>

      <span
        className="
          rounded-full
          bg-[#E8F7F5]
          px-3
          py-1
          text-sm
          font-semibold
          text-[#3BAFA3]
        "
      >
        {value}
      </span>
    </div>
  );
}